import React from "react";
const PrivacyPolicy = () => {
  return (
    <section className="relative py-20 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-red-50 to-pink-50 w-full overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-orange-200/30 rounded-full blur-3xl -translate-x-48 -translate-y-48"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-200/30 rounded-full blur-3xl translate-x-48 translate-y-48"></div>
      <div className="relative max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex px-5 py-2 bg-white rounded-full shadow-md mb-4">
            <span className="text-sm font-semibold text-red-600">
              Legal Information
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900">
            Privacy{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Policy
            </span>
          </h2>
          <p className="text-gray-600 mt-3 max-w-2xl mx-auto text-sm md:text-base">
            Last updated: January 1, 2024
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-orange-100">
          <div className="p-6 md:p-10">
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Introduction
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                Asha Modern School ("we," "our," or "us") is committed to protecting your privacy. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
                when you visit our website or use our services.
              </p>
              <p className="text-gray-600 text-sm leading-relaxed">
                Please read this privacy policy carefully. If you do not agree with the terms of this 
                privacy policy, please do not access the site.
              </p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Information We Collect
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                We may collect information about you in a variety of ways. The information we may 
                collect on the Site includes:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 text-sm ml-4">
                <li>Personal Data: Name, email address, phone number, and other contact information</li>
                <li>Child Information: Child's name, age, grade level, and educational records</li>
                <li>Payment Data: Payment information such as credit card numbers and billing addresses</li>
                <li>Usage Data: Information about how you use our website and services</li>
              </ul>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                How We Use Your Information
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                Having accurate information about you permits us to provide you with a smooth, efficient, 
                and customized experience. Specifically, we may use information collected about you via 
                the Site to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 text-sm ml-4">
                <li>Process admission applications and enrollment forms</li>
                <li>Communicate with parents/guardians about school activities and events</li>
                <li>Send periodic newsletters and important announcements</li>
                <li>Process fee payments and maintain financial records</li>
                <li>Improve our website and educational services</li>
                <li>Comply with legal obligations and school policies</li>
              </ul>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Disclosure of Your Information
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                We may share information we have collected about you in certain situations. Your 
                information may be disclosed as follows:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 text-sm ml-4">
                <li>By Law or to Protect Rights: If required by law or public authority</li>
                <li>Business Transfers: In connection with any merger, sale of school assets, or financing</li>
                <li>With Your Consent: We may share your information with third parties with your consent</li>
                <li>Service Providers: We may share your information with third parties that perform services for us</li>
              </ul>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Security of Your Information
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We use administrative, technical, and physical security measures to help protect your 
                personal information. While we have taken reasonable steps to secure the personal 
                information you provide to us, please be aware that despite our efforts, no security 
                measures are perfect or impenetrable, and no method of data transmission can be 
                guaranteed against any interception or other type of misuse.
              </p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Cookies and Tracking Technologies
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We may use cookies, web beacons, tracking pixels, and other tracking technologies on 
                the website to help customize the Site and improve your experience. You can set your 
                browser to refuse all or some browser cookies, or to alert you when websites set or 
                access cookies. If you disable or refuse cookies, please note that some parts of this 
                site may become inaccessible or not function properly.
              </p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Children's Privacy
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We are committed to protecting the privacy of children. We do not knowingly collect 
                personal information from children under 13 without parental consent. If you are a 
                parent or guardian and believe your child has provided us with personal information 
                without your consent, please contact us immediately.
              </p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Your Rights and Choices
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                Depending on your location, you may have certain rights regarding your personal information:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 text-sm ml-4">
                <li>Access and update your personal information</li>
                <li>Request deletion of your personal information</li>
                <li>Opt-out of marketing communications</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Third-Party Websites
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Our website may contain links to third-party websites. We are not responsible for the 
                privacy practices or the content of these third-party sites. We encourage you to read 
                the privacy policies of any linked websites you visit.
              </p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Changes to This Privacy Policy
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We may update this Privacy Policy from time to time. The updated version will be 
                indicated by an updated "Last updated" date and the updated version will be effective 
                as soon as it is accessible. We encourage you to review this Privacy Policy frequently 
                to be informed of how we are protecting your information.
              </p>
            </div>
            <div className="mb-6">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Contact Us
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                If you have questions or comments about this Privacy Policy, please contact us at:
              </p>
              <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-5">
                <p className="text-gray-700 text-sm mb-2">
                  <strong className="text-red-600">Asha Modern School</strong>
                </p>
                <p className="text-gray-600 text-sm mb-1">
                  Address: Address 2, Mani Nagar, Kandwa Road, Chitaipur, Varanasi
                </p>
                <p className="text-gray-600 text-sm mb-1">
                  Phone: +91-9839961911
                </p>
                <p className="text-gray-600 text-sm">
                  Email: info@ashamodernschool.com
                </p>
              </div>
            </div>
            <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-5 border-l-4 border-red-600">
              <p className="text-gray-700 text-sm">
                <strong>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="text-center mt-8">
          <button 
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-orange-500 text-white font-semibold text-sm py-2.5 px-6 rounded-lg hover:shadow-lg hover:scale-105 transition-all duration-300"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Back to Home
          </button>
        </div>
      </div>
    </section>
  );
};
export default PrivacyPolicy;